module.exports = __webpack_public_path__ + "static/standard-0fa9bc4fda8e57ec8c44bd6e36eb0ea4.svg";